import React, { Fragment } from 'react';
import Slider from 'react-slick';
import { UncontrolledTooltip } from 'reactstrap';

import settings from './SlickSettings';
import { directConnectionData } from './data';

const LocalServiceProvider = () => (
  <Fragment>
    <div className="container mb-1 d-none d-lg-block py-4">
      <div className="row">
        <div className="col-12">
          <h2 className="text-uppercase text-center section-header">
            STEP 3: EMPOWER LOCAL COMMUNITIES
          </h2>
          <p className="font-weight-normal text-center">
            HoneyGuide helps remote mountain communities digitize their tourism activities.
          </p>
          <hr className="hr--small mb-4" />
          <div className="hexagon-perfect-trek-container hexagon-perfect-trek-container--small">
            {directConnectionData &&
              directConnectionData.map(data => {
                const {
                  ownerName,
                  classNameNumber,
                  img,
                  lodgeName,
                  location,
                  desc,
                  url,
                } = data;
                const firstName = ownerName.split(' ')[0];
                return (
                  <a
                    key={ownerName}
                    id={firstName}
                    className={`hexagon-wrapper hexagon-wrapper-${classNameNumber} has-popper`}
                    href={url}
                  >
                    <div className="hexagon hexagon--perfect-trek hexagon--small">
                      <div
                        id={ownerName}
                        className="hexagon-background"
                        style={{ backgroundImage: `url(${img})` }}
                      />
                    </div>
                    <UncontrolledTooltip
                      placement="right"
                      target={firstName}
                      className="tooltip--connection"
                    >
                      <h3>{lodgeName}</h3>
                      <div className="location">{location && `( ${location} )`} </div>
                      <p>{desc}</p>
                      <div className="author">- {ownerName}</div>
                    </UncontrolledTooltip>
                  </a>
                );
              })}
          </div>
        </div>
      </div>
    </div>

    {/* for smaller devices */}
    <div className="d-lg-none">
      <div className="container">
        <div className="row">
          <div className="col py-4">
            <h2 className="text-uppercase text-center section-header">
              STEP 3: BOOK YOUR TREKS DIRECTLY, AND HELP THE LOCAL COMMUNITY.
            </h2>
            <p className="font-weight-normal text-center">
              Empower the local service providers of the mountain community by booking
              directly through them as you craft your experience!
            </p>
            <hr className="hr--small mb-4" />
          </div>
        </div>
      </div>

      <div id="slick-direct-connection" className="slick-direct-connection">
        <Slider {...settings}>
          {directConnectionData.map(
            ({ ownerName, img, lodgeName, location, desc, url }) => (
              <a href={url} key={ownerName}>
                <div className="slick-direct-connection-slide">
                  <div className="slick-direct-connection-slide-content">
                    <div className="container">
                      <div className="row">
                        <div className="col-sm-4 col-md-3 pl-5 pr-5 p-sm-0 ml-2 mr-2 m-sm-0">
                          <div className="hexagon-wrapper hexagon-wrapper--full">
                            <div className="hexagon">
                              <div
                                className="hexagon-background"
                                style={{ backgroundImage: `url(${img})` }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8 col-md-9">
                          <div className="pl-5 ml-md-5">
                            <div className="quote mt-4">
                              <h3>{lodgeName}</h3>
                              <div className="text-muted">{location}</div>
                              <p>{desc}.</p>
                              <div className="author">- {ownerName}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            )
          )}
        </Slider>
      </div>
    </div>
  </Fragment>
);

export default LocalServiceProvider;



// WEBPACK FOOTER //
// ./src/screens/Landing/LocalServiceProvider.jsx